const Button = ({
  type = "button",
  onClick,
  variant = "primary",
  size = "md",
  btncls = "",
  text,
  children,
  loading = false,
  style = {},
  ...rest
}) => {
  const className =
    `btn btn-${variant} btn-${size} ${btncls}  rounded-1`.trim();

  return (
    <button
      type={type}
      className={className}
      onClick={onClick}
      {...rest}
      style={{
        padding: "6px 0.75rem",
        ...style,
      }}
      disabled={loading}
    >
      {loading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {children || text}
        </>
      ) : (
        children || text
      )}
    </button>
  );
};

export default Button;
